import React from "react"
import { usePageTitle } from "src/hooks/usePageTitle"

/**
 * Visually hides content while keeping it available to screen readers
 * (the standard "visually hidden" / sr-only technique).
 */
const visuallyHidden: React.CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
  border: 0,
}

/**
 * Syncs the document title with the route and announces the current screen to
 * screen readers on client-side navigation — the SPA router does neither on its
 * own (WCAG 2.4.2). Render once inside the router.
 */
const RouteAnnouncer: React.FC = () => {
  const pageTitle = usePageTitle()
  return (
    <div aria-live="polite" role="status" style={visuallyHidden}>
      {pageTitle}
    </div>
  )
}

export default RouteAnnouncer
